var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLargePdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.625 0 7.5 1.125 7.5 2.5V37.5C7.5 38.875 8.625 40 10 40H35C36.375 40 37.5 38.875 37.5 37.5V10L27.5 0H10Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5L30 10H37.5V17.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94531 23.6841C7.94531 23.3541 8.20531 22.9941 8.62406 22.9941H10.9328C12.2328 22.9941 13.4028 23.8641 13.4028 25.5316C13.4028 27.1116 12.2328 27.9916 10.9328 27.9916H9.26406V29.3116C9.26406 29.7516 8.98406 30.0004 8.62406 30.0004C8.29406 30.0004 7.94531 29.7516 7.94531 29.3116V23.6841ZM9.26406 24.2529V26.7429H10.9328C11.6028 26.7429 12.1328 26.1516 12.1328 25.5316C12.1328 24.8329 11.6028 24.2529 10.9328 24.2529H9.26406Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3619 30.0002C15.0319 30.0002 14.6719 29.8202 14.6719 29.3815V23.704C14.6719 23.3452 15.0319 23.084 15.3619 23.084H17.6506C22.2181 23.084 22.1181 30.0002 17.7406 30.0002H15.3619ZM15.9919 24.304V28.7815H17.6506C20.3494 28.7815 20.4694 24.304 17.6506 24.304H15.9919Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7372 24.3843V25.973H26.2859C26.6459 25.973 27.0059 26.333 27.0059 26.6818C27.0059 27.0118 26.6459 27.2818 26.2859 27.2818H23.7372V29.3805C23.7372 29.7305 23.4884 29.9993 23.1384 29.9993C22.6984 29.9993 22.4297 29.7305 22.4297 29.3805V23.703C22.4297 23.3443 22.6997 23.083 23.1384 23.083H26.6472C27.0872 23.083 27.3472 23.3443 27.3472 23.703C27.3472 24.023 27.0872 24.383 26.6472 24.383H23.7372V24.3843Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargePdf);
export default __webpack_public_path__ + "static/media/large_pdf.c06826219b138448b6975ada7f74328c.svg";
export { ForwardRef as ReactComponent };